import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions("patient", ["deletePatient", "Patientdeactive"]),
  },
};
